// @flow
import Enum from '@rover/shared/js/types/Enum';

export class APIVersion extends Enum<string> {
  static v3 = new APIVersion('v3');

  static v4 = new APIVersion('v4');

  static v5 = new APIVersion('v5');
}



// WEBPACK FOOTER //
// ../utilities/apiVersion.js